export default __webpack_public_path__ + "images/open-chat.00e7a98e.svg";